import { render, staticRenderFns } from "./ListPLPage.vue?vue&type=template&id=44d359a2&"
import script from "./ListPLPage.vue?vue&type=script&lang=js&"
export * from "./ListPLPage.vue?vue&type=script&lang=js&"
import style0 from "./ListPLPage.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports